import {
  Operator,
  Brand,
  CasinoGame,
  CasinoData,
  CasinoDataError,
  CasinoDataPending,
  CasinoDataSuccess
} from "@fresh8/types/src";
import { isSuccess } from "../lib/provideInjectors";
import { onBeforeMount, Ref, ref, watch } from "vue";
import properties from "../properties";

function getRandomInt(min: number, max: number): number {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getRandomItemFromArray<T>(arr: T[]): T {
  const index = getRandomInt(0, arr.length - 1);
  return arr[index];
}

export function useFetchCasinoData(
  brand: Ref<Brand>,
  selectedOperator: Ref<Operator>,
  isCasinoCampaign: boolean
): Ref<CasinoData> {
  if (
    !brand.value?.adTemplate?.cardOrdering?.general.includes("casino") &&
    !isCasinoCampaign
  )
    return ref({
      data: {
        highlight: {} as CasinoGame,
        list: [] as CasinoGame[],
        raw: {
          amount_of_games: 0,
          games: []
        }
      },
      status: "success"
    } as CasinoDataSuccess);

  const data = ref<CasinoData>({
    data: null,
    status: "pending"
  } as CasinoDataPending);

  const fetching = ref(false);

  async function fetchData(operator: string) {
    try {
      const url = new URL(properties.dataCasinoApiUri);

      const params = new URLSearchParams({ operator });

      const headers = new Headers({
        ["Accept"]: "application/json"
      });

      fetching.value = true;

      const res = await fetch(`${url}${params}`, {
        method: "GET",
        mode: "cors", // no-cors, *cors, same-origin
        cache: "default",
        headers
      });

      const json = await res.json();

      fetching.value = false;

      data.value = {
        data: {
          highlight: getRandomItemFromArray(json.games),
          list: json.games,
          raw: json
        },
        status: "success"
      } as CasinoDataSuccess;
    } catch (e) {
      data.value = {
        data: e,
        status: "error"
      } as CasinoDataError;
    }
  }

  onBeforeMount(() => {
    fetchData(selectedOperator.value.key);
  });

  watch(selectedOperator, op => {
    if (!fetching.value) {
      data.value = {
        data: null,
        status: "pending"
      };
      fetchData(op.key);
    }
  });

  return data;
}
